fragment ConversionAreaOneFragment on conversionAreaOne_Entry {
  typeHandle
  isAdjusted
  shopifyHandle
}
